import { updateVendor } from "../../../../actions/CarrierAgreementMgmt/Vendor";
import { useMutation } from "react-query";
import { toast } from "../../../../components/toastNotification";
import { useRecoilState } from "recoil";
import { editStateVendor, vendorShowState } from "../atoms/atoms";

const useUpdateVendor = () => {
  const [actionEditState, setEditState] = useRecoilState(editStateVendor);
  const [, setShowState] = useRecoilState(vendorShowState);
  const { mutate } = useMutation(
    async (VendorNewData) => updateVendor(VendorNewData),
    {
      onSuccess: (res) => {
        toast.fire("Success", "Vendor updated successfully.", "success");
        setEditState(!actionEditState);
        setShowState(false);
      },
      onError: () => {
        toast.fire("Failed", "Failed to update vendor.", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateVendor;
